import { render, staticRenderFns } from "./teacher-activate-report.vue?vue&type=template&id=0fd7ef06&scoped=true"
import script from "./teacher-activate-report.vue?vue&type=script&lang=js"
export * from "./teacher-activate-report.vue?vue&type=script&lang=js"
import style0 from "./teacher-activate-report.vue?vue&type=style&index=0&id=0fd7ef06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd7ef06",
  null
  
)

export default component.exports